import * as actions from './constants';

export const defaultState = {
    email: null,
    loading: false,
    error: null,
    sent: false
}

export default function(state = defaultState, action) {
    const { type, payload, error=null } = action;
    switch (type) {
        case actions.RESETREQUEST_START:
            return {
                ...defaultState,
                email: payload?.email,
                loading: true
            }
        case actions.RESETREQUEST_SUCCESS:
            return {
                ...defaultState,
                email: state.email,
                sent: true
            }
        case actions.RESETREQUEST_FAILURE:
            return {
                ...defaultState,
                error
            }
        default:
            return state;
    }
}
